var API_DOMAIN = "https://viswacrackersbilling.zentexus.in/api";

export default API_DOMAIN;
